export const SOCKET_URL = `${process.env.CLIENT_BASE_PATH}/cable`
export const QUIZ_PREFIXS = ['A', 'B', 'C', 'D']
export const ACCESS_TOKEN = 'access_token'
export const NAME = 'name'
export const RANK = 'rank'
export const UID = 'uid'
export const CLIENT = 'client'
export const STRIPE_PK = process.env.STRIPE_PUBLIC_KEY
export const NO_IMAGE_URL = `${process.env.ADMIN_DOMAIN}/images/noimage.png`
export const LP_IMAGE_URL = `${process.env.ADMIN_DOMAIN}/images/top_visual.jpg`
export const ACCEPT_FILE_TYPES = ['image/png', 'image/jpg', 'image/jpeg', 'image/bmp']
